<template>
  <div class="expand-to-2">
    <div>
      <p class="text-zt-xl font-bold mb-8">
        Selecciona el archivo a enviar
      </p>
      <p class="text-zt-base w-11/12 text-zt-dark-300 mb-2">
        Puedes utilizar los siguientes tipos de archivos
      </p>
      <div class="details flex justify-start items-center mb-8">
        <zt-chip square outline>PDF</zt-chip>
        <zt-chip square outline>MAX 3MB</zt-chip>
      </div>
    </div>

    <div>
      <zt-input-file
        v-model="file"
        outlined
        append-icon="paperclip-2"
        filetypes=".pdf"
        label="Subir archivo"
        :redIfError="errorMsg"
        @change="onChangeInput"
      >
        <template slot="message">
          <span v-if="errorMsg" class="text-zt-danger">{{ errorMsg }}</span>
        </template>
      </zt-input-file>

      <div v-show="file"
        class="preview-file flex items-center justify-center text-base mt-4 py-2 cursor-pointer font-semibold border dark-700 rounded"
        @click="modalPreviewActive = true"
      >
        <zt-icon
          class="text-lg no-underline"
          name="eye"
        />
        <p class="ml-3 text-preview">
          Previsualizar archivo
        </p>
      </div>
    </div>
    <zt-modal
      class="modal-preview"
      :active="modalPreviewActive"
      :z-index="1000"
      @close="modalPreviewActive = false"
      @shown="shownModal"
    >
      <template slot="modal-header">
        <div class="p-4 text-center font-bold">
          <h4>
            {{ $t(`message.publishDocuments.onlySign.modalPreviewDocument.title`) }}
          </h4>
        </div>
      </template>
      <template>
        <div class="relative">
          <div class="pdf-container" ref="containerPdf">
            <div class="w-full h-full absolute left-0 top-0">
              <zt-pdf-viewer
                :fixed-rotation="false"
                :minZoom=".15"
                :page="curPage"
                :rotate="rotation"
                :scale=".30"
                :src="base64"
                :key="reRenderKey"
                @viewer-update="normalizeRotation"
                @page-count="totalsPages = $event"
              />
            </div>
          </div>
          <div v-if="totalsPages > 0" class="w-full absolute bottom-0 flex justify-center items-center my-4">
            <button @click="prevPage"><zt-icon name="angle-left" /></button>
            <div>
              {{ curPage }} de {{ totalsPages }}
            </div>
            <button @click="nextPage"><zt-icon name="angle-right" /></button>
          </div>
        </div>
      </template>
      <template slot="modal-footer">
        <div
          class="flex justify-end items-center text-md p-4 bottom-0 w-full bg-zt-dark-200"
        >
          <zt-button @click="modalPreviewActive = false">
            {{ $t(`message.publishDocuments.onlySign.modalPreviewDocument.buttonClose`) }}
          </zt-button>
        </div>
      </template>
    </zt-modal>
  </div>
</template>

<script>
const MAX_FILE_SIZE = 10485760
const FILE_TYPE = 'application/pdf'

export default {
  name: "PublishLoadDocument",
  data() {
    return {
      errorMsg: '',
      file: '',
      base64: '',
      modalPreviewActive: false,
      rotation: 0,
      pdfLoaded: false,
      totalsPages: 0,
      curPage: 1,
      reRenderKey: 0
    }
  },
  watch: {
    file(val) {
      if (!val) {
        this.errorMsg = ''
        this.clearFile()
      }
    }
  },
  methods: {
    onChangeInput(file) {
      if (file.size >= MAX_FILE_SIZE) {
        this.errorMsg = 'El documento no debe superar los 10MB'
        return null
      }
      if (file.type !== FILE_TYPE) {
        this.errorMsg = 'El tipo de documento no es permitido. Deberá ser PDF.'
        return null
      }
      if (this.errorMsg) this.errorMsg = ''
      const reader = new FileReader()
      reader.onload = (event) => {
        this.base64 = event.target.result
      }
      reader.readAsDataURL(file)
      this.file = file
      this.$emit('change-file', file)
    },
    clearFile() {
      this.file = ''
      this.base64 = ''
      this.modalPreviewActive = false
      this.$emit('clear-file')
    },
    normalizeRotation(doc) {
      this.pdfLoaded = true
      if (doc.page.pdfPageRotate > 0) {
        this.rotation = doc.page.pdfPageRotate * -1
      }
    },
    nextPage() {
      if (this.curPage < this.totalsPages) this.curPage++
    },
    prevPage() {
      if (this.curPage > 1) this.curPage--
    },
    shownModal() {
      this.$nextTick(() => {
        this.reRenderKey += 1
        this.curPage = 1
        this.totalsPages = 0
        this.pdfLoaded= false
        this.$refs.containerPdf.getBoundingClientRect()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.pdf-container {
  width: 100%;
  height: 500px;
  position: relative;
  overflow: hidden;
}
.preview-file {
  width: 180px;
}
.dark-700 {
  color: #707070;
}
.details {
  ::v-deep {
    .zt-chip {
      background: #EBEBEB!important;
    }
  }
}
::v-deep {
  .zt-input-appended-icon {
    font-size: 1.5rem!important;
  }

  .zt-input-text-field {
    .zt-chip {
      color: #261C77!important;
      font-weight: 400!important;
      padding-left: .5rem!important;
      padding-right: .5rem!important;
    }
  }
  .zt-modal-body {
    border-radius: 0!important;
  }
}
</style>